<template>
  <div class="min-h-screen font-sans transition-colors duration-300">
    <div
      class="bg-background-light dark:bg-background-dark text-slate-800 dark:text-slate-100"
    >
      <section class="container mx-auto px-4 py-12">
        <div class="text-center mb-16">
          <h2
            class="text-3xl font-bold text-center mb-5 text-gray-700 title-underline uppercase"
          >
            About HDSilicone
          </h2>
        </div>

        <div class="mx-auto space-y-6 text-md leading-relaxed text-gray-600">
          <p>
            Dongguan Huadai Silicone Co., Ltd. was founded in 2017 and located
            in Dongguan, Guangdong, China, which is a National High tech
            Enterprise specializing in R&D, manufacturing and sales of silicone
            rubber. The company covers an area of 30,000 square meters, with an
            annual production capacity of 35000 tons, of which HCR is 30,000
            tons and LSR is 5,000 tons.
          </p>
          <p>
            Huadai has a strict quality control system underpinned by ISO9001
            international quality management system, ensuring full traceability
            across every production stage from raw material sourcing to finished
            product delivery. By selecting high-grade raw materials, applying
            scientific management practices, and conducting rigorous testing, we
            consistently deliver products of high and stable quality. Our
            dedication to quality is further validated by compliance with a
            range of international certifications including ROHS, REACH, FDA,
            and LFGB. Guided by our original and earnest spirit, we ensure every
            batch of products meets the highest standards, laying a solid
            foundation for our sustainable growth and customer trust.
          </p>
          <p>
            HDSilicone series of products: liquid silicone rubber, insulating
            silicone rubber, fumed silicone rubber, flame retardant silicone
            rubber, roller silicone rubber etc. Because of their excellent
            characteristics such as high and low-temperature resistance,
            electrical properties, weathering and age resistance, physiological
            inertness, it is widely used in automobiles, electronics,
            electricity, baby products, toys, home appliances, medical equipment
            and so on.
          </p>
          <p>
            We will work hand in hand with our customer and friends to create a
            more fruitful and better future! Welcome people from all over the
            world to consult the factory inspection.
          </p>
        </div>
      </section>

      <section class="container mx-auto px-4 py-12">
        <div class="text-center mb-16">
          <h2 class="text-3xl font-bold text-center mb-5 text-gray-700">
            FACTORY TOUR
          </h2>
        </div>
        <div class="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div
            v-for="(item, index) in images"
            :key="'f-' + index"
            class="group"
          >
            <div
              class="aspect-square bg-slate-50 dark:bg-slate-800 rounded-2xl p-6 mb-4 flex items-center justify-center overflow-hidden"
            >
              <img
                :alt="item"
                class="w-full h-full object-contain group-hover:scale-110 transition-transform duration-300"
                :src="item"
              />
            </div>
          </div>
        </div>
      </section>

      <section class="bg-custom-blue py-16">
        <div class="container h-[450px] mx-auto px-4 items-center">
          <iframe
            class="h-full w-full"
            src="https://www.youtube.com/embed/ieWSok2k5ng"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
      </section>

      <section class="py-16">
        <div class="container mx-auto px-8 py-8 bg-[#ededed]">
          <email-sender></email-sender>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import EmailSender from '@/components/emailform/Email'
export default {
  name: 'AboutUs',
  components: { EmailSender },
  data() {
    return {
      images: [
        require('@/assets/factory/001.jpg'),
        require('@/assets/factory/002.jpg'),
        require('@/assets/factory/003.jpg'),
        require('@/assets/factory/004.jpg'),
        require('@/assets/factory/005.jpg'),
        require('@/assets/factory/006.jpg'),
        require('@/assets/factory/007.jpg'),
        require('@/assets/factory/008.jpg'),
        require('@/assets/factory/009.jpg'),
        require('@/assets/factory/010.jpg'),
        require('@/assets/factory/011.jpg'),
        require('@/assets/factory/012.jpg')
      ]
    }
  },
  mounted() {},
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.title-underline {
  position: relative;
  display: inline-block;
}
.title-underline::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -10px;
  width: 100%;
  height: 8px;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 20" preserveAspectRatio="none"><path d="M0 15 Q 25 5, 50 15 T 100 15" stroke="%23004494" stroke-width="4" fill="transparent"/></svg>');
  background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/page/aboutus/Aboutus.vue